import React, { useEffect, useState, useContext } from "react";
import { UserContext } from "../context/UserContext";
import OrderDetailModal from "../components/Modals/OrderLineItemsModal";
import { useHistory } from "react-router-dom";
import { API_BASE } from "../utils/api";
import { duplicateOrder as duplicateOrderUtil } from "../utils/duplicateOrder";

export default function OrdersPage() {
  const { user } = useContext(UserContext);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const history = useHistory();
  useEffect(() => {
    if (!user) return;

    const fetchOrders = async () => {
      try {
        const response = await fetch(
          `${API_BASE}/orders-ultra/api/ws/list_orders_ecommerce?id_customer=${user.idCustomer}&id_ship_to=${user.idShipTo}&clase=*&tipo=PE`
        );

        const data = await response.json();
        setOrders(data);
      } catch (error) {
        console.error("Error cargando pedidos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [user]);

  // ===================== DUPLICAR PEDIDO =====================
  const duplicateOrder = (order, items) => duplicateOrderUtil(order, items, { history });

  if (loading) {
    return (
      <div className="p-10 text-gray-500 text-center">Cargando ordenes...</div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-10 mt-16 mb-6">
      {/* TITULO */}
      <h1 className="text-3xl font-bold text-gray-800 mb-1">
        Consulta de Ordenes
      </h1>

      <div className="space-y-2 max-h-[500px] overflow-y-auto pr-2">
        {/* ENCABEZADOS */}
        <div
          className="
            hidden md:grid
            grid-cols-8
            px-4 py-3 bg-gray-100 border-b border-gray-300
            text-gray-700 font-semibold text-sm
            sticky top-0 z-20
        "
        >
          <span>Usuario</span>
          <span>Fecha</span>
          <span>Número</span>
          <span>Orden de Compra</span>
          <span className="text-right">Total</span>
          <span className="text-center">Estado</span>
          <span>Notas</span>
          <span></span>
        </div>

        {/* SIN PEDIDOS */}
        {orders.length === 0 && (
          <p className="text-gray-500">No tienes ordenes registrados...</p>
        )}

        {/* LISTA */}
        {orders.map((o, index) => (
          <div
            key={o.orderId}
            onClick={() => {
              setSelectedOrder(o);
              setModalOpen(true);
            }}
            className="
              bg-white border border-gray-200 rounded-lg p-3 shadow-sm
              grid grid-cols-1 md:grid-cols-8
              gap-2 items-center
              hover:bg-gray-200 hover:shadow-lg transition
              cursor-pointer
            "
          >
            {/* USUARIO */}
            <div className="flex items-center gap-3">
              <span
                className="inline-flex items-center justify-center
                  w-6 h-6 rounded-md bg-gray-200 text-gray-700
                  text-[11px] font-bold"
              >
                {index + 1}
              </span>

              <span className="text-gray-800 font-medium text-sm">
                {o.employeeId}
              </span>
            </div>

            {/* FECHA */}
            <div className="text-gray-700 text-sm">
              {new Date(o.orderDate).toLocaleDateString("es-ES", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                  })}
            </div>

            {/* NÚMERO */}
            <div className="text-gray-800 font-semibold text-sm">
              {o.orderNumber}
            </div>

            {/* ORDEN DE COMPRA */}
            <div className="text-gray-800 font-semibold text-sm">
              {o.invoiceNumber ?? "—"}
            </div>

            {/* TOTAL */}
            <div className="text-ultra-red text-right font-bold text-sm">
              ${Number(o.total || 0).toFixed(2)}
            </div>

            {/* ESTADO */}
            <span
              className="
                inline-block px-2 py-1 text-[11px] font-semibold rounded-md
                text-center text-black-700
              "
            >
              {o.crossId === null ? "PENDIENTE" : "FACTURADO"}
            </span>

            {/* NOTAS */}
            <div className="text-gray-500 text-xs">
              {o.notes ?? "—"}
            </div>
          </div>
        ))}
      </div>

      {/* MODAL DE DETALLES */}
      <OrderDetailModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        order={selectedOrder}
        onDuplicate={duplicateOrder}
      />
    </div>
  );
}
